import { BookingStatisticFiltered } from '../types/booking-statistic-filtered';
import { StatisticsVariant } from '../types/statistic-variant';
import { TFunction } from 'i18next';
// import { monthMap } from './calendar';
import { ContentType } from '../types/content-type';
import { CurveType, LineSeriesType, XAxis } from '@mui/x-charts';

export const prepareLineChartStatisticsData = (
  data: BookingStatisticFiltered[],
  _variant: StatisticsVariant,
  contentType: ContentType,
  tStatistics: TFunction<['statistics', 'common'], undefined>,
  // tCommon: TFunction<['common'], undefined>,
): {
  xAxis: XAxis[];
  series: readonly LineSeriesType[];
} => {
  const dates = data.map(d => d.date);
  const roomValues = data.map(d => d._filteredROOM);
  const deskValues = data.map(d => d._filteredDESK);

  const seriesBase: {
    labelMarkType: 'circle';
    type: 'line';
    curve: CurveType;
  } = {
    labelMarkType: 'circle',
    type: 'line',
    curve: 'linear',
  };

  const xAxis: XAxis[] = [
    {
      data: dates,
      // variant === 'DAILY'
      //   ? dates
      //   : dates.map(
      //       date =>
      //         `${tCommon(`common:calendar.months.${monthMap[date.split('-')[1]]}`)} ${date.split('-')[0]}`,
      //     ),
      scaleType: 'point',
    },
  ];
  const series =
    contentType === 'DESK'
      ? [
          {
            label: tStatistics('common.chart.legend.desk'),
            data: deskValues,
            color: '#D76C2D',
            ...seriesBase,
          },
        ]
      : contentType === 'ROOM'
        ? [
            {
              label: tStatistics('common.chart.legend.room'),
              data: roomValues,
              color: '#008000',
              ...seriesBase,
            },
          ]
        : [
            {
              label: tStatistics('common.chart.legend.room'),
              data: roomValues,
              color: '#008000',
              ...seriesBase,
            },
            {
              label: tStatistics('common.chart.legend.desk'),
              data: deskValues,
              color: '#D76C2D',
              ...seriesBase,
            },
          ];

  return {
    xAxis,
    series,
  };
};
